import { useGet } from "@albertine/api-client";
import type { ListRequestsSortField } from "@albertine/types/openapi/lmt";
import { mapListRequestsItemToRequest } from "../../utils/request.adapter";

const MEMBER_REQUESTS_PAGE_SIZE = 1000;

type MemberRequestsOptions = {
    size?: number;
    sortBy?: ListRequestsSortField;
    sortOrder?: "asc" | "desc";
};

export function memberRequestsQueryParams(
    memberId: string,
    { size, sortBy, sortOrder }: MemberRequestsOptions = {},
) {
    return {
        query: {
            memberId,
            size: String(size ?? MEMBER_REQUESTS_PAGE_SIZE),
            page: "0",
            sortBy: sortBy ?? "startDateTime",
            sortOrder: sortOrder ?? "desc",
        },
    };
}

export function useMemberRequests(memberId: string, options?: MemberRequestsOptions) {
    return useGet("requests", memberRequestsQueryParams(memberId, options), {
        select: (response) => response.requests.map(mapListRequestsItemToRequest),
    });
}
